import React from 'react';
import {KeolisSpinner} from '../containers/common/commonExport';

const PrintInProgress = (props) => (
    <div className="printContainer">
        <div className={'printOverlay ' + (props.printStatus === true ? '' : 'hidden')}></div>
        <div className={'printProgress ' + (props.printStatus ? '' : 'hidden')}>
            <span>Print/Export in progress </span>
            <KeolisSpinner />
        </div>
    </div>
);

export default PrintInProgress;